import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { __, getLocale } from 'i18n-for-browser';

import Defines from '../../Defines';
import CloseIcon from "../../assets/img/close.png";
import { getContent, getNext, getAllTourPopups } from '../../helpers/popupHelper';
import { Player, ControlBar, VolumeMenuButton } from 'video-react';

class PopUp extends React.Component {
  static propTypes = {
    closePopUpClick: PropTypes.func,
    id: PropTypes.string,
    elementFocus: PropTypes.string,
    showPopUp: PropTypes.bool,
    description: PropTypes.string, // description for custom popup
    title: PropTypes.string, // title for custom popup
    img: PropTypes.string, // img for custom popup
    buttonText: PropTypes.string,
    hideClose: PropTypes.bool,
    popUpFooter: PropTypes.bool,
    closePopUpCross: PropTypes.bool,
    customButton: PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
    }),
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    closePopUpClick: () => {},
    hideClose: false,
    interactive: false,
    closePopUpCross: false,
    zIndex: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      history: [props.id],
      count: getAllTourPopups(props.id),
      cur: 1,
      isFullscreen: false,
      interactive: this.props.interactive,
      hideClose: this.props.hideClose,
      confirmButtons: false,
      buttonText: this.props.buttonText,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillMount() {
    if (!this.props.popUpFooter) {
      document.body.classList.add('noScroll');
    }
    if(this.props.showHeader){
      document.body.classList.add('popup--showHeader');
    }

    this.popupSettings(this.props.id);
  }

  componentDidMount() {
    const first = this.props.id;
    const tourCount = getAllTourPopups(first);

    if(this.props.showHeader){
      document.body.classList.add('popup--showHeader');
    }

    this.setState({count: tourCount});

    document.addEventListener("keydown", this.handleKeyPress);
    if((this.props.popUpFooter || this.props.customButton) && !this.props.closePopUpCross) {
      window.addEventListener('mousedown', this.props.closePopUpClick);
    }

    if (this.state.interactive) {
      window.addEventListener('mousedown', this.handleClick);
    }

    if (this.refs.player) {
      this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));
    }

  }

  handleStateChange(state) {
    const { isFullscreen } = this.state;
    if (state.isFullscreen !== isFullscreen) {
      this.setState({
        isFullscreen: state.isFullscreen
      })
    }
  }

  componentWillUnmount() {
    if (!this.props.popUpFooter) {
      document.body.classList.remove('noScroll');
    }
    if(this.props.showHeader) {
      document.body.classList.remove('popup--showHeader');
    }

    document.removeEventListener("keydown", this.handleKeyPress);
    if ((this.props.popUpFooter || this.props.customButton) && !this.props.closePopUpCross) {
      window.removeEventListener('mousedown', this.props.closePopUpClick);
    }
    if (this.state.interactive) {
      window.removeEventListener('mousedown', this.handleClick);
    }

  }

  handleClick(event) {
    if (
      document.getElementsByClassName('popup').length &&
      !document.getElementsByClassName('popup')[0].contains(event.target)
  ){
      this.props.closePopUpClick();
    }
  }

  handleKeyPress(event) {
    if (event.keyCode === 27) {
      if (!this.state.hideClose) {
        this.props.closePopUpClick();
      }
    }
  }

  /**
   * Method to show next popup
   */
  showNext = (ev, nextId) => {
    const { state } = this;

    ev.stopPropagation();
    let { history, cur } = state;
    history.push(nextId);
    cur++;
    this.setState({ history, cur });
  };

  /**
   * Method to show previous popup
   */
  showPrev = (ev) => {
    ev.stopPropagation();
    let { history, cur } = this.state;
    history.pop();
    --cur;
    this.setState({ history, cur });
  };

  popupSettings = (popupId) => {
    if(popupId && popupId.substr(3,1) === 'm'){
      const popup = Defines.popups[popupId];
      if(!popup) return;
      switch (popup.Type) {
        case "A":
          this.setState({
            interactive: true,
            hideClose: false,
          })
          break;
        case "B":
          this.setState({
            interactive: false,
            hideClose: true,
            confirmButtons: true,
            confirmButtonsSave: true,
          });
          break;
        case "H":
          this.setState({
            interactive: false,
            hideClose: true,
            buttonText: __('sim_terug_naar_startscherm'),
          });
        break;
        case "I":
          this.setState({
            interactive: false,
            hideClose: true,
            confirmButtons: true,
            confirmButtonsSave: false,
          });
          break;
        case "J":
          this.setState({
            interactive: false,
            hideClose: true,
            cancelButtons: true,
          });
          break;
        default:
          return
      }
    }
  }

  closePopup = (e) => {
    console.log("CLOOOOSSEEEEEEE");
    this.setShowPopup();
    this.props.closePopUpClick(e);
  }

  setShowPopup = () => {
    const key = this.props.showIfUnread;
    if(key) {
      sessionStorage.setItem(key, 'true');
    }
  }

  getShowPopup = () => {
    const key = this.props.showIfUnread;
    if(key) {
      const res = sessionStorage.getItem(key);
      if(res && res === 'true') {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  render() {
    const { props, showPrev, showNext, state } = this;
    const { isFullscreen } = state;
    const popupId = state.history[state.history.length - 1];
    const isPortal = window.location.pathname.indexOf('portal') !== -1 || window.location.pathname.indexOf('login') !== -1;
    let nextId = '';
    if (popupId) {
      nextId = getNext(popupId);
    }
    if(!this.getShowPopup()) return null;

    const centerPopupIds = ['mhgvtintro_welkom', 'dhgvtintro_welkom', 'mlgvtintro_welkom', 'dlgvtintro_welkom',
      'dhbvtintro_welkom', 'dlbvtintro_welkom', 'dhbvtghettoradio_1', 'dlbvtghettoradio_1',
      'mhbvtintro_welkom', 'mlbvtintro_welkom', 'mhbvtghettoradio_1', 'mlbvtghettoradio_1'];
    const popup = Defines.popups[popupId];
    const language = props.gameState.loaded ? props.gameState.language : (getLocale() || 'NL').toUpperCase();
    return (
      ReactDOM.createPortal(
        <div style={this.props.zIndex ? { zIndex: this.props.zIndex } : {}} className={"popup-container" + (props.showPopUp ? ' show' : '') + (props.popUpFooter ? ' footer' : '') + (isPortal ? ' is-portal' : '')}>
          <div className={'popup-spacer-desktop'}/>
          <div className={'container'}>
            <div className={'align-right-two-third'}>
              <div className={"popup" + (props.video ? ' video-popup' : '') + (props.className ? ' ' + props.className : '')} ref={node => this.node = node}>
                {this.props.closePopUpCross && !this.state.hideClose ?
                  <div onClick={(e) => this.closePopup(e)} className="top-right-close-button close-button">
                    <span className="close-icon">
                      <img src={CloseIcon} height='15' alt=''/>
                    </span>
                  </div>
                  : null }

                { (nextId < 1 || !nextId) && nextId !== '' && state.history.length < 2 && !this.state.hideClose && !(props.popUpFooter) ? (
                  <div onClick={(e) => this.closePopup(e)} className="top-right-close-button close-button">
                    <span className="close-icon">
                      <img src={CloseIcon} height='15' alt=''/>
                    </span>
                  </div>
                ) : null }

                {popupId ? (
                  <Fragment>
                    <div className="popup-content" style={centerPopupIds.indexOf(popupId) > -1 ? {textAlign: 'center'} : {}} dangerouslySetInnerHTML={{ __html: getContent(popupId, language) }} />
                    <div className={`popup-navigation ${`type-${String(popup.Type).toLowerCase()}`}`}>
                      {state.history.length > 1 ? (
                        <button className={"button--white tut-prev"} onClick={(ev) => { showPrev(ev); }}>
                          <span>{__('sim_vorige_button')}</span>
                        </button>
                      ) : null }
                      { state.count > 1 ? (
                        <div className={'tutorial-counter'}>
                          <span>{state.cur}</span>
                          /
                          <span>{state.count}</span>
                        </div>
                      ) : null }
                      {nextId ? (
                        <button className={'tut-next'} onClick={(ev) => { showNext(ev, nextId)}}>
                          <span>{__('sim_volgende_button')}</span>
                        </button>
                      ) : null }
                      { state.count > 1 && state.count === state.cur ? (
                        <button className={'tut-close'} onClick={(e) => this.closePopup(e)}>
                          <span>{__('sim_aan_de_slag_button')}</span>
                        </button>
                      ) : null }
                      <div className="button-container">
                        {state.buttonText ? (
                          <button onClick={(e) => this.closePopup(e)}>
                            <span>{__(state.buttonText)}</span>
                          </button>
                        ) : null}
                      </div>
                      {!this.state.confirmButtons ? null :
                        (
                          <div className="button-container">
                            <button onClick={_ => props.closePopUpClick(false)}>
                              <span>{__((this.state.confirmButtonsSave ? 'sim_button_ja_terug' : 'Nee'))}</span>
                            </button>
                            <button onClick={_ => props.closePopUpClick(true)}>
                              <span>{__((this.state.confirmButtonsSave ? 'sim_button_nee_opslaan' : 'Ja'))}</span>
                            </button>
                          </div>
                        )
                      }
                      {!this.state.cancelButtons ? null :
                        (
                          <div className="button-container">
                            <button onClick={_ => props.closePopUpClick(false)}>
                              <span>{__('sim_annuleren')}</span>
                            </button>
                            <button onClick={_ => props.closePopUpClick(true)}>
                              <span>Ok</span>
                            </button>
                          </div>
                        )
                      }
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    {props.img ? (<img alt="popup" className={(props.imgClass ? props.imgClass : '')} src={props.img} />) : null}
                    {props.video ? (
                      <div onClick={() => {
                          props.closePopUpClick();
                        }} className="top-right-close-button close-button">
                        <span className="close-icon">
                          <img src={CloseIcon} height='15' alt=''/>
                        </span>
                      </div>
                    ) : null }
                    {props.video ? (
                      <Player
                        autoPlay
                        muted
                        className={'videoframe ' + (isFullscreen ? ' fullscreen' : '')}
                        ref="player"
                        src={props.video} >
                        <ControlBar autoHide={isFullscreen}>
                          <VolumeMenuButton vertical />
                        </ControlBar>
                      </Player>
                    ) : null }
                    {props.title ? (<h3>{__(props.title)}</h3>) : null}
                    {props.description ? (<p dangerouslySetInnerHTML={{ __html: __(props.description) }}></p>) : null}
                    {props.children ? (props.children) : null}
                    <div className="button-container">
                      {state.buttonText ? (
                        <button onClick={(e) => this.closePopup(e)}>
                          <span>{__(state.buttonText)}</span>
                        </button>
                      ) : null}
                      {props.customButton ? (
                        <button onClick={props.customButton.action} onTouchStart={props.customButton.action}>
                          <span>{__(props.customButton.text)}</span>
                        </button>
                      ) : null}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      , document.body)
    );
  }
}

export default connect(state => ({ gameState: state.gameState }))(PopUp);



// WEBPACK FOOTER //
// ./src/components/elements/PopUp.js